<div class="table">
  <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows class="mat-elevation-z8">

    <ng-container matColumnDef="label">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="label" class="cell_text"> Date / Identification
      </th>
      <td mat-cell *matCellDef="let element" class="cell_text"> {{element.dateLib}} </td>
    </ng-container>

    <ng-container matColumnDef="startDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="startDate" class="cell_club"> Date de début </th>
      <td mat-cell *matCellDef="let element" class="cell_club"> {{element.sessionStartDate | formatDate}} </td>
    </ng-container>

    <ng-container matColumnDef="endDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="endDate" class="cell_club"> Date de fin </th>
      <td mat-cell *matCellDef="let element" class="cell_club"> {{element.sessionEndDate  | formatDate}} </td>
    </ng-container>

    <ng-container matColumnDef="quantity">
      <th mat-header-cell *matHeaderCellDef class="cell_quantity"> Nbr de participants/max </th>
      <td mat-cell *matCellDef="let element" class="cell_quantity">
        <div class="cell_quantity_content">
          <div class="faCheckCircle">
            <fa-icon [icon]="getFaIcon('faCheckCircle')" *ngIf="element.bookedSessionTrainees === element.quantity"></fa-icon>
          </div>
          <span>{{element.bookedSessionTrainees}}/{{element.quantity}} </span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="isActive">
      <th mat-header-cell *matHeaderCellDef class="cell_action" [style.text-align]="'right !important'"> Act./Dés. </th>
      <td mat-cell *matCellDef="let element" class="cell_action" [style.text-align]="'center'">
        <mat-slide-toggle size="large" (toggleChange)="isActivatedOrDeactivated(element) " [color]="color"
          [checked]="element?.isActive"></mat-slide-toggle>
      </td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef class="cell_action" [style.text-align]="'right'"> Éditer </th>
      <td mat-cell *matCellDef="let element" class="cell_action" [style.text-align]="'center'">
        <fa-icon [icon]="getFaIcon('faPen')" (click)="editSession(element)"></fa-icon>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"> </tr>
  </table>
  <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" (page)="pageEvent = $event"
    [color]="color">
  </mat-paginator>
</div>
